<div class="container">
  <mat-card>
    <form [formGroup]="accountingRuleForm" (ngSubmit)="submit()">
      <mat-card-content>
        <div fxLayout="row wrap" fxLayoutGap="2%" fxLayout.lt-md="column">
          <mat-form-field fxFlex="48%">
            <mat-label>{{ 'labels.inputs.Accounting Rule Name' | translate }}</mat-label>
            <input matInput required formControlName="name" />
            <mat-error *ngIf="accountingRuleForm.controls.name.hasError('required')">
              {{ 'labels.inputs.Accounting Rule Name' | translate }} {{ 'labels.commons.is' | translate }}
              <strong>{{ 'labels.commons.required' | translate }}</strong>
            </mat-error>
          </mat-form-field>

          <mat-form-field fxFlex="48%">
            <mat-label>{{ 'labels.inputs.Office' | translate }}</mat-label>
            <mat-select required formControlName="officeId">
              <mat-option *ngFor="let office of officeData" [value]="office.id">
                {{ office.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="accountingRuleForm.controls.officeId.hasError('required')">
              {{ 'labels.inputs.Office' | translate }} {{ 'labels.commons.is' | translate }}
              <strong>{{ 'labels.commons.required' | translate }}</strong>
            </mat-error>
          </mat-form-field>

          <div fxFlex="48%" fxLayout="row" fxLayout.lt-md="column" class="rule-wrapper">
            <mat-label fxFlex="50%">{{ 'labels.inputs.Affected GL Entry (Debit) Rule Type' | translate }} *</mat-label>
            <mat-radio-group fxFlex="50%" fxLayout="row" fxLayoutGap="5%" formControlName="debitRuleType">
              <mat-radio-button value="fixedAccount">{{ 'labels.inputs.Fixed Account' | translate }}</mat-radio-button>
              <mat-radio-button value="listOfAccounts">{{
                'labels.inputs.List of Accounts' | translate
              }}</mat-radio-button>
            </mat-radio-group>
          </div>

          <mat-form-field fxFlex="48%" *ngIf="accountingRuleForm.controls.debitRuleType.value === 'fixedAccount'">
            <mat-label>{{ 'labels.inputs.Account to Debit' | translate }}</mat-label>
            <mat-select formControlName="accountToDebit">
              <mat-option *ngFor="let glAccount of glAccountData" [value]="glAccount.id">
                {{ glAccount.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <div
            fxFlex="48%"
            fxLayout="row"
            fxLayoutGap="2%"
            fxLayout.lt-md="column"
            *ngIf="accountingRuleForm.controls.debitRuleType.value === 'listOfAccounts'"
          >
            <mat-form-field fxFlex="50%">
              <mat-label>{{ 'labels.inputs.Debit Tags' | translate }}</mat-label>
              <mat-select formControlName="debitTags" multiple>
                <mat-option *ngFor="let debitTag of debitTagData" [value]="debitTag.id">
                  {{ debitTag.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <div fxFlex="50%" ngClass.gt-md="entries-wrapper">
              <mat-checkbox labelPosition="before" formControlName="allowMultipleDebitEntries" class="entries">
                {{ 'labels.inputs.Multiple Debit Entries Allowed' | translate }}
              </mat-checkbox>
            </div>
          </div>

          <div fxFlex="48%" fxLayout="row" fxLayout.lt-md="column" class="rule-wrapper">
            <mat-label fxFlex="50%">{{ 'labels.inputs.Affected GL Entry (Credit) Rule Type' | translate }} *</mat-label>
            <mat-radio-group fxFlex="50%" fxLayout="row" fxLayoutGap="5%" formControlName="creditRuleType">
              <mat-radio-button value="fixedAccount">{{ 'labels.inputs.Fixed Account' | translate }}</mat-radio-button>
              <mat-radio-button value="listOfAccounts">{{
                'labels.inputs.List of Accounts' | translate
              }}</mat-radio-button>
            </mat-radio-group>
          </div>

          <mat-form-field fxFlex="48%" *ngIf="accountingRuleForm.controls.creditRuleType.value === 'fixedAccount'">
            <mat-label>{{ 'labels.inputs.Account to Credit' | translate }}</mat-label>
            <mat-select formControlName="accountToCredit">
              <mat-option *ngFor="let glAccount of glAccountData" [value]="glAccount.id">
                {{ glAccount.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <div
            fxFlex="48%"
            fxLayout="row"
            fxLayoutGap="2%"
            fxLayout.lt-md="column"
            *ngIf="accountingRuleForm.controls.creditRuleType.value === 'listOfAccounts'"
          >
            <mat-form-field fxFlex="50%">
              <mat-label>{{ 'labels.inputs.Credit Tags' | translate }}</mat-label>
              <mat-select formControlName="creditTags" multiple>
                <mat-option *ngFor="let creditTag of creditTagData" [value]="creditTag.id">
                  {{ creditTag.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <div fxFlex="50%" ngClass.gt-md="entries-wrapper">
              <mat-checkbox labelPosition="before" formControlName="allowMultipleCreditEntries" class="entries">
                {{ 'labels.inputs.Multiple Credit Entries Allowed' | translate }}
              </mat-checkbox>
            </div>
          </div>

          <mat-form-field fxFlex="98%">
            <mat-label>{{ 'labels.inputs.Description' | translate }}</mat-label>
            <textarea matInput formControlName="description" cdkTextareaAutosize cdkAutosizeMinRows="2"></textarea>
          </mat-form-field>
        </div>
      </mat-card-content>

      <mat-card-actions fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center" fxLayoutGap="5px">
        <button type="button" mat-raised-button [routerLink]="['../../']">
          {{ 'labels.buttons.Cancel' | translate }}
        </button>
        <button
          mat-raised-button
          color="primary"
          [disabled]="!accountingRuleForm.valid"
          *mifosxHasPermission="'CREATE_ACCOUNTINGRULE'"
        >
          {{ 'labels.buttons.Submit' | translate }}
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
</div>
